const mapJsonToProps = ({ content_rows }) => ({
  specs: content_rows,
});

export default mapJsonToProps;
